<template>
  <div class="preview-page">
    <div class="head-image"
         :style="
        form.imgsCut
          ? { 'background-image': `url(${form.imgsCut})` }
          : form.imgs
          ? { 'background-image': `url(${form.imgs})` }
          : {
              'background-image': `url(${importTransform2()})`
            }
      ">
      <div class="head-container">
        <div class="title-bar">
          <div class="avatar"
               :style="
              form.avatar
                ? { 'background-image': `url(${form.avatar})` }
                : { 'background-image': `url(${importTransform()})` }
            "></div>
          <div class="title-content">
            <p class="title"
               :title="form.name">
              {{
                form.name.length > 20
                  ? `${form.name.slice(0, 20)}...`
                  : form.name
              }}
            </p>
            <p class="author">
              <span class="author-info name">{{
                form.nickName
                  ? form.nickName
                  : `用户${this.$cookie.get("userInfo_userId")}`
              }}</span>
              <span class="author-info time">发表时间：{{ form.beginDate | formatTime }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="travel-container">
      <div class="travel-info padding-top-50">
        <template v-for="(items, index) in form.nodeList"
                  style="position: relative">
          <div class="info-level2"
               :ref="'node' + index">
            <div class="info-content-level2">
              <div class="title-level2">
                <p class="monitorTarget">{{ items.name }}</p>
              </div>
              <template v-for="(itemschild, j) in items.paragraphList">
                <div class="info-content-level3"
                     :ref="'nodechild' + index + j">
                  <div class="level3-title"
                       v-if="itemschild.name">
                    <span class="icon-span"
                          :style="{
                        'background-image': `url(${imageMapping(
                          itemschild.name
                        )}`
                      }"></span>
                    <span class="text-span monitorTarget">{{
                      itemschild.name
                    }}</span>
                  </div>
                  <template v-for="(itemschildchild, z) in itemschild.bodyList">
                    <div class="level3-content">
                      <div v-if="itemschildchild.type === 1">
                        <div class="content-item">
                          <img v-if="itemschildchild.content"
                               :src="itemschildchild.content" />
                        </div>
                      </div>
                      <div v-else-if="itemschildchild.type === 2">
                        <div class="content-item">
                          <video v-if="itemschildchild.content"
                                 controls="controls"
                                 :src="itemschildchild.content"></video>
                        </div>
                      </div>
                      <div v-else-if="itemschildchild.type === 4">
                        <div class="content-item">
                          <p style="line-height:2em">{{ itemschildchild.content }}</p>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
      <div class="travel-navi">
        <div class="travel-navi-info">
          <p>
            <span>
              <img src="~@/assets/images/preview/playway.png" />
            </span>
            <span>
              玩法：{{
                form.playTypeIdList ? form.playTypeIdList : "--" | getplayWay
              }}
            </span>
          </p>
          <p>
            <span>
              <img src="~@/assets/images/preview/partner.png" />
            </span>
            <span>
              和谁去：{{ form.tourPar ? form.tourPar : "--" | gettourPar }}
            </span>
          </p>
          <p>
            <span>
              <img src="~@/assets/images/preview/traveldate.png" />
            </span>
            <span>开始日期：{{
                form.beginDate ? form.beginDate : "--" | formatTime
              }}</span>
          </p>
          <p>
            <span>
              <img src="~@/assets/images/preview/days.png" />
            </span>
            <span>游玩天数：{{ form.playDays ? `${form.playDays}天` : "--" }}</span>
          </p>
          <p>
            <span>
              <img src="~@/assets/images/preview/totalMileage.png" />
            </span>
            <span>
              总里程数：{{
                form.totalMileage ? `${form.totalMileage}公里` : "--"
              }}
            </span>
          </p>
          <p>
            <span>
              <img src="~@/assets/images/icons/icon-drive-difficulty-colorful.png" />
            </span>
            <span>
              驾驶难度：{{
                form.difficulty ? form.difficulty : "--" | getdifficulty
              }}
            </span>
          </p>
          <p>
            <span>
              <img src="~@/assets/images/icons/icon-expenditure-colorful.png" />
            </span>
            <span>人均消费：{{ form.price ? `${form.price}元` : "--" }}</span>
          </p>
        </div>
        <div class="travel-navi-content"
             :style="tNaviStyle"
             ref="tNavi">
          <div class="navi-title">
            <p>目录导航</p>
          </div>
          <div class="navi-content">
            <div class="gray-bar"></div>
            <div class="navi-content-area">
              <el-scrollbar style="height:100%">
                <template v-for="(items, index) in form.nodeList">
                  <div class="navi-item naviTarget"
                       :key="`navi${index}`"
                       :ref="`navi${index}`">
                    <p class="left-line">
                      <span class="thin-line line-top"></span>
                      <span class="small-point"
                            :class="naviChecked == index ? 'checked-ball' : ''"></span>
                      <span class="thin-line line-bottom"></span>
                    </p>
                    <p class="item-text level2-navi-item"
                       :class="naviChecked == index ? 'checked-text' : ''"
                       @click="nodeClick($event, items, index)">
                      {{ items.name }}
                    </p>
                  </div>
                  <template v-for="(itemschild, j) in items.paragraphList">
                    <div class="navi-item naviTarget"
                         v-if="itemschild.name !== ''"
                         :key="`navi${index}${j}`"
                         :ref="`navi${index}${j}`">
                      <p class="left-line">
                        <span class="thin-line line-top"></span>
                        <span class="small-point"
                              :class="
                            naviChildChecked == `${index}${j}`
                              ? 'checked-ball'
                              : ''
                          "></span>
                        <span class="thin-line line-bottom"></span>
                      </p>
                      <p class="item-text level3-navi-item"
                         :class="
                          naviChildChecked == `${index}${j}`
                            ? 'checked-text'
                            : ''
                        "
                         @click="nodechildClick($event, index, j)">
                        {{ itemschild.name }}
                      </p>
                    </div>
                  </template>
                </template>
              </el-scrollbar>
            </div>
          </div>
          <div class="navi-footer">
            <div class="navi-btn review"
                 @click="Back">继续编辑</div>
            <div class="navi-btn release"
                 @click="Release('3')">发布</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import api from "../../axios/api";
import Global from "../../utils/Global";
import service from "../../axios/service/service";
import { commonFilter } from "./commonFilter.js";
import imgUrlToIdMixin from "@/mixins/imgUrlToId.js";

export default {
  mixins: [commonFilter, imgUrlToIdMixin],
  data () {
    return {
      tNaviStyle: {},
      imageUrl: "",
      collapse: false,
      form: {},
      id: "",
      naviChecked: "",
      naviChildChecked: "",
      imageOfType: {
        穿衣指南: require("@/assets/images/icons/type/dressing.png"),
        注意事项: require("@/assets/images/icons/type/attention.png"),
        温馨提示: require("@/assets/images/icons/type/hint.png"),
        避坑秘籍: require("@/assets/images/icons/type/cheats.png"),
        民族风俗: require("@/assets/images/icons/type/custom.png"),
        禁忌: require("@/assets/images/icons/type/taboo.png"),
        必备物品: require("@/assets/images/icons/type/must.png"),
        剁手清单: require("@/assets/images/icons/type/listing.png"),
        交通: require("@/assets/images/icons/type/traffic.png"),
        美食推荐: require("@/assets/images/icons/type/cate.png"),
        节日: require("@/assets/images/icons/type/festival.png"),
        不能错过: require("@/assets/images/icons/type/cannotmiss.png")
      }
    };
  },
  watch: {
    findtreveldetail (value) {
      this.form = value[0];
    }
  },
  computed: {
    ...mapState("WriteDataStore", ["writeData"]),
    ...mapState("HomeDataStore", ["checkform"]),
    ...mapState("NewTravelStore", ["findtreveldetail"])
  },
  methods: {
    ...mapMutations("WriteDataStore", ["back"]),
    ...mapActions("NewTravelStore", [
      "findtrevelNotesdetail",
      "findTravelDetailOld"
    ]),
    collapseToggle () {
      this.collapse = !this.collapse;
    },
    nodeClickPatch (showTarget) {
      let naviArr = document.querySelectorAll(".naviTarget");
      naviArr = Array.prototype.slice.call(naviArr);
      naviArr.forEach(targetNavi => {
        targetNavi.children[0].children[1].classList.remove("checked-ball");
        targetNavi.children[1].classList.remove("checked-text");
      });
      this.$refs[showTarget][0].children[0].children[1].classList.add(
        "checked-ball"
      );
      this.$refs[showTarget][0].children[1].classList.add("checked-text");
    },
    nodeClick (e, items, index) {
      this.naviChecked = index;
      this.naviChildChecked = "~";
      window.scrollTo(0, this.$refs[`node${index}`][0].offsetTop);
      this.nodeClickPatch(`navi${index}`);
    },
    nodechildClick (e, index, j) {
      this.naviChecked = "~";
      this.naviChildChecked = `${index}${j}`;
      window.scrollTo(0, this.$refs[`nodechild${index}${j}`][0].offsetTop);
      this.nodeClickPatch(`navi${index}${j}`);
    },
    importTransform () {
      return import("@/assets/images/travel/avatar-default.png");
    },
    importTransform2 () {
      return import("@/assets/images/travel/cover.png");
    },
    imageMapping (value) {
      if (this.imageOfType[value]) {
        return this.imageOfType[value];
      }
      return import("@/assets/images/icons/type/cannotmiss.png");
    },
    Back () {
      this.form = { ...this.form, ...this.formData };
      this.back(this.form);
      this.$router.push({ path: `/traveling/${this.id}` });
    },
    //发布
    async Release (state) {
      if (this.form.name === "" || !this.form.imgs) {
        this.$message("好的封面标题，会让你受到更多青睐");
        return;
      }
      this.form = { ...this.form, ...this.formData };
      this.form.compositionType = 2; //游记
      this.form.state = 1; //2.保存3.发布
      this.form.userId = this.$cookie.get("userInfo_userId");
      const callBackFun = () => {
        service.save(this.form, "info/saveTravelNote").then(json => {
          if (json.respCode === 100 && json.respCode !== undefined) {
            this.$router.push({ name: "success" });
          } else {
            if (state === 2) {
              return;
            } else {
              Global.messageErr("发布失败");
            }
          }
        });
      };
      await this.handeleCoverImage(callBackFun);
    },
    handleScroll () {
      //获取监听的正文dom对象
      let monitoArr = document.querySelectorAll(".monitorTarget");
      //对NodeList应用Array的方法
      monitoArr = Array.prototype.slice.call(monitoArr);
      //找到首个top大于0的 （首个内容完整的）
      let naviIndex = monitoArr.findIndex(targetEle => {
        //获得dom的矩形区域
        let rect = targetEle.getBoundingClientRect();
        return rect.top > 0;
      });
      //获取监听的右侧目录dom对象
      let naviArr = document.querySelectorAll(".naviTarget");
      naviArr = Array.prototype.slice.call(naviArr);
      naviArr.forEach((targetNavi, index) => {
        if (index === naviIndex) {
          targetNavi.children[0].children[1].classList.add("checked-ball");
          targetNavi.children[1].classList.add("checked-text");
        } else {
          targetNavi.children[0].children[1].classList.remove("checked-ball");
          targetNavi.children[1].classList.remove("checked-text");
        }
      });
    }
  },
  created () {
    document.title = "游记编辑_自驾出游好帮手_鹿驾网";
    //获取id对应的数据
    this.id = this.$route.params.id;
    // fromWhere 用于标记哪个页面调用法的 findtrevelNotesdetail
    this.findTravelDetailOld({ id: this.id, fromWhere: "preview" });

    this.$root.showWriteBall = false;
    this.$eventHub.$on("windowScroll", data => {
      if (data.scrollTop > 950) {
        if (data.scrollBottom < 100) {
          this.tNaviStyle = {
            position: "fixed",
            bottom: `${(document.documentElement.clientHeight ||
              document.body.clientHeight) - 420}px`,
            left: `${this.$refs.tNavi.offsetLeft}px`
          };
        } else {
          this.tNaviStyle = {
            position: "fixed",
            top: "0px",
            left: `${this.$refs.tNavi.offsetLeft}px`
          };
        }
      } else {
        this.tNaviStyle = {};
      }
    });
  },
  mounted () {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed () {
    window.localStorage.setItem("state", "");
  }
};
</script>
<style lang="less">
@import "~@/lesses/main/travel/preview.less";
</style>
